import { gql } from "@stadium/services/apollo-client/server";

export const STORE_DETAILS = gql`
  fragment StoreDetails on Store {
    code: shopCodeWithWorkspaceSlug
    config {
      currencyCode
      currencyName
      currencyPrefix
      currencySuffix
      displayCurrencyId
      currencyFactor
      displayCurrencyId
      customCurrency
      upcharge
    }
    maxPrice
    minPrice
    createdAt
    id
    logo
    enableCeilPrices
    name
    topBanner
    productsThumbImage: productImage
    url
    feUrl: feUrlWithWorkspaceSlug
    externalId
    number
    private
    customDomainUrl
    customDomainVerified
    customDomainEnabled
    currencyType
    active
    pointsMigrationAllowed
    containsMerch
    hideBulkPricing
    storeDetail {
      sendToManyEnabled
      whitelistedDomains
      whitelistedEmails
      templateType
      pastelCanvasId
      pastelCatalogUrl
      pastelUrl
      featuredMenuHidden
      allowToPublish
      searchIndexed
      hideCountryFlags
      workspaceAccessible
      allowAllUsersSendPoints
      allowAllUsersSendItems
    }
    firstMarketingCategory {
      id
      slug
    }
    availableDisplayCurrencies {
      id
      name
      currencyKey
      symbol
    }
    membership {
      customDomain
      customPointConversion
      whitelabel
    }
    banner {
      id
      privateMetadata
    }
    qrCodeImage
  }
`;
